// Checked

import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import flag8 from "../../../assets/images/flag8.png";
import TextField from "@material-ui/core/TextField";
import flag_bd4 from "../../../assets/images/flag_bd4.png";
import flag_usa4 from "../../../assets/images/flag_usa4.png";
import { TransferContext } from "../../../context/TransferContext";

const useStyles = makeStyles(() => ({
  marginBottomStyle: {
    marginBottom: "10px",
  },

  inputStyle: {
    borderRadius: "8px",
  },
  inputStyle2: {
    borderRadius: "8px",
    // "& .MuiInputBase-input": {
    //   color: "#A2A2A2",
    // },
    "& .MuiSelect-outlined.MuiSelect-outlined": {
      fontSize: "14px",
      padding: 13,
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
    },
  },
  textField: {
    [`& fieldset`]: {
      borderRadius: 8,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: "14px",
    },
    "& .MuiOutlinedInput-inputMarginDense": {
      padding: 13,
    },
  },
  selectStyle: {
    textAlign: "left",

    "& img": {
      position: "relative",
      top: "2px",
      marginRight: "5px",
    },
  },
  selectItemStyle: {
    fontWeight: 600,
  },
  inputRoot: {
    "& .MuiOutlinedInput-input": {
      // color: "green",
      // fontWeight: 600,
    },
    "& .MuiInputLabel-root": {
      // color: "green",
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "#eee",
      // backgroundColor: "#eee",
      color: "#333",
    },
    "&:hover .MuiOutlinedInput-input": {
      // color: "red",
    },
    "&:hover .MuiInputLabel-root": {
      // color: "red",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      // borderColor: "red",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      // color: "purple",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      // color: "purple",
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      // borderColor: "purple",
    },
  },
  flag: {
    marginRight: 10,
    width: 20,
    position: "relative",
    top: 4,
  },
  select: {
    "& .MuiSelect-select:focus": {
      backgroundColor: "#fff",
      borderWidth: 0,
    },
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#fff",
    },
    padding: "5px",
    height: 45,
    borderRadius: 8,
  },
}));
const ReceiverDetails = () => {
  const classes = useStyles();
  const { addToTransfer, transfer } = useContext(TransferContext);

  const [banks, setBanks] = useState([]);
  const [branches, setBranches] = useState([]);
  // const [bankId, setBankId] = useState(transfer.bankId && transfer.bankId);
  const [bankId, setBankId] = useState("na");
  const [branchId, setBranchId] = useState(
    transfer.branchId && transfer.branchId
  );
  const [accountName, setAccountName] = useState(transfer.accountName);
  const [mobileNumber, setMobileNumber] = useState(transfer.r_phone);
  const [phoneCode, setPhoneCode] = useState(
    transfer.toCountry && transfer.toCountry.phone
  );
  const [loading, setLoading] = useState(false);

  const getBank = async () => {
    try {
      let res = await axios({
        url: "/api/v1/public/bank",
        method: "get",
      });

      setBanks(res.data.data);

      console.log("bank", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
  };

  const getBranch = async (bank_id) => {
    setLoading(true);
    try {
      let res = await axios({
        url: `api/v1/public/bank/${bank_id}/branch`,
        method: "get",
      });

      setBranches(res.data.data);

      console.log("branch", res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
    setLoading(false);
  };

  const handleBank = (e) => {
    console.log(e.target.value);
    getBranch(e.target.value);
    setBankId(e.target.value);
    addToTransfer({ bankId: e.target.value });
  };
  const handleBranch = (e) => {
    console.log(e.target.value);
    setBranchId(e.target.value);
    addToTransfer({ branchId: e.target.value });
  };
  const handleAccountName = (e) => {
    setAccountName(e.target.value);
    addToTransfer({ accountName: e.target.value });
  };

  const HandleMobileNumber = (e) => {
    setMobileNumber(e.target.value);
    addToTransfer({ r_phone: e.target.value });

    addToTransfer({ accountNumber: `${e.target.value}` });
  };

  useEffect(() => {
    getBank();
  }, []);

  return (
    <>
      {/* <Typography variant="h4" className={classes.marginBottomStyle}>
        Receiver Details
      </Typography> */}
      <Grid container alignItems="center" spacing={3}>
        {loading ? (
          <Grid item xs={12}>
            <LinearProgress />
          </Grid>
        ) : null}
        <Grid item xs={3}>
          <Typography variant="body1">Bank Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              labelId="MFS-name-outlined-label"
              id="MFS-name-outlined"
              defaultValue="na"
              displayEmpty
              value={bankId}
              onChange={handleBank}
              className={classes.inputStyle2}
            >
              <MenuItem disabled value="na">
                <span style={{ color: "#999" }}>Select Bank</span>
              </MenuItem>
              {banks.map((e, index) => (
                <MenuItem value={e.id} key={index}>
                  {e.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body1">Branch Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <FormControl variant="outlined" size="small" fullWidth>
            <Select
              labelId="MFS-name-outlined-label"
              id="MFS-name-outlined"
              defaultValue="na"
              value={branchId}
              onChange={handleBranch}
              className={classes.inputStyle2}
            >
              <MenuItem disabled value="na">
                <span style={{ color: "#999" }}>Select Branch</span>
              </MenuItem>
              {branches.map((e, index) => (
                <MenuItem value={e.id} key={index}>
                  {e.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body1">Account Name</Typography>
        </Grid>
        <Grid item xs={9}>
          <TextField
            id="account-name"
            size="small"
            fullWidth
            placeholder="Enter Account Name"
            variant="outlined"
            className={classes.textField}
            value={accountName}
            onChange={handleAccountName}
          />
        </Grid>

        <Grid item xs={3}>
          <Typography variant="body1">Account Number</Typography>
        </Grid>

        <Grid item xs={9}>
          <TextField
            id="number"
            size="small"
            fullWidth
            variant="outlined"
            placeholder="Enter Account Number"
            className={classes.textField}
            value={mobileNumber}
            onChange={HandleMobileNumber}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ReceiverDetails;
